import type { SavedMapView } from "./map-camera.ts";

export const HOME_VIEW_PARAM = "view";

/** `view` query: lng,lat,zoom,bearing[,pitch] */
export function formatViewParam(view: SavedMapView): string {
  const [lng, lat] = view.center;
  const pitch = view.pitch ?? 0;
  return `${lng},${lat},${view.zoom},${view.bearing},${pitch}`;
}

export function parseViewParam(raw: string | null): SavedMapView | null {
  if (!raw?.trim()) return null;
  const parts = raw.split(",").map((s) => Number(s.trim()));
  if (parts.length < 4 || parts.slice(0, 4).some((n) => !Number.isFinite(n))) return null;
  const [lng, lat, zoom, bearing] = parts;
  const pitch =
    parts.length >= 5 && Number.isFinite(parts[4]!) ? parts[4]! : 0;
  return { center: [lng!, lat!], zoom: zoom!, bearing: bearing!, pitch };
}

export function formatHomeBrowseUrl(
  questId: string | null,
  view: SavedMapView | null,
): string {
  const params = new URLSearchParams();
  if (questId) params.set("id", questId);
  if (view) params.set(HOME_VIEW_PARAM, formatViewParam(view));
  const q = params.toString();
  return q ? `/?${q}` : "/";
}

export function parseHomeBrowseSearch(search: string): {
  questId: string | null;
  view: SavedMapView | null;
} {
  const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
  return {
    questId: params.get("id"),
    view: parseViewParam(params.get(HOME_VIEW_PARAM)),
  };
}

export function stripHomeBrowseViewFromUrl(href = location.href): string {
  const url = new URL(href);
  if (!url.searchParams.has(HOME_VIEW_PARAM)) return `${url.pathname}${url.search}`;
  url.searchParams.delete(HOME_VIEW_PARAM);
  const q = url.searchParams.toString();
  return `${url.pathname}${q ? `?${q}` : ""}`;
}
